import { useTranslation } from 'react-i18next';
// material
import { enUS, frFR, esES } from '@material-ui/core/locale';

// ----------------------------------------------------------------------

const LANGS = [
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/static/icons/ic_flag_en.svg'
  },
  {
    label: 'Français',
    value: 'fr',
    systemValue: frFR,
    icon: '/static/icons/ic_flag_fr.svg'
  },
  {
    label: 'Español',
    value: 'es',
    systemValue: esES,
    icon: '/static/icons/ic_flag_es.svg'
  }
];

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();
  const langStorage = localStorage.getItem('i18nextLng');
  const currentLang = LANGS.find((_lang) => _lang.value === langStorage) || LANGS[0];

  const handleChangeLanguage = (newlang) => {
    i18n.changeLanguage(newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate,
    currentLang,
    allLang: LANGS
  };
}
